import "./style.css";
import { TopMenu } from "../../components/topmenu/TopMenu";
import { baseURL,fileUrl } from "../../constants/index";

export function Contacts() {
  return (
    <div id="contact" className="contact_div">
      <div className="contact_title_page">
        <div className="contact_t_div">
          <img src="./img/lainxibt.png" />
        </div>
      </div>
      <div className="contact_items_page">
        <div className="contact_info_div">
          <p>
            <span className="contact_info_txt">联系方式：</span>
          </p>
          <p>
            <span className="contact_info_txt">
              地 址：北京市朝阳区安翔北里甲11号北京创业大厦A座东门3层
            </span>
          </p>
          <p>
            <span className="contact_info_txt">
              浙江省德清县科源路11号1幢国遥大厦10层
            </span>
          </p>
          <p>
            <span className="contact_info_txt">电 话：010-64875535</span>
          </p>
          <p>
            <span className="contact_info_txt">传 真：010-64870409</span>
          </p>
          <p>
            <span className="contact_info_txt">
              网 址：www.earthstar.com.cn
            </span>
          </p>
        </div>
        <div className="contact_qrcode_div">
          <img className="contact_qrcode" src="./img/qrcode.jpg" />
        </div>
        <div className="contact_video_div">
          <div className="video_div">
            <video
              src={baseURL+fileUrl+"video.mp4"}
              autoPlay="autoplay"
              loop="loop"
              muted={true}
              type="video/mp4"
              className="video_item"
              controls
            ></video>
          </div>
        </div>
        <div className="copyrigt_div">
          <p>
            <span className="copyright_txt">
              版权所有：环球星云遥感科技有限公司
            </span>
            <span className="copyright_beian_txt">
              <img className="copyright_img" src="./img/beian.png" />
              <a className="copyright_link" href="https://beian.mps.gov.cn/#/query/webSearch?code=33052102001059" rel="noreferrer" target="_blank">浙公网安备33052102001059</a>
            </span>
            <span className="copyright_beian_txt">
              <a href="http://beian.miit.gov.cn" className="copyright_link">
                浙ICP备2021004889号-2
              </a>
            </span>
          </p>
        </div>
      </div>

      <TopMenu />
    </div>
  );
}
